import { render, staticRenderFns } from "./Carbonara.vue?vue&type=template&id=330df520&scoped=true&"
import script from "./Carbonara.vue?vue&type=script&lang=js&"
export * from "./Carbonara.vue?vue&type=script&lang=js&"
import style0 from "./Carbonara.vue?vue&type=style&index=0&id=330df520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330df520",
  null
  
)

export default component.exports